export default function formatPrettyNumber(
  number: number | bigint | string,
  options?: Intl.NumberFormatOptions
): string {
  return new Intl.NumberFormat('en-US', options).format(
    typeof number === 'string' ? Number(number) : number
  );
}
